import fetch from 'unfetch'
import mitt from 'mitt'
import app from '../app.js'

const ev = mitt()

export const on = ev.on

export function addVariant (variant, quantity) {
  const numAvailable = variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify' ? (
    variant.inventory_quantity
  ) : null // null means they can add as many as they want

  return fetchCart().then(({ items }) => {
    const existing = items.filter(item => item.id === variant.id)[0] || {}
    const numRequested = (existing.quantity || 0) + quantity

    if (numAvailable !== null && numRequested > numAvailable) {
      const err = `There are only ${numAvailable} of that product available, requested ${numRequested}.`
      ev.emit('error', err)
      throw new Error(err)
    } else {
      return addItemById(variant.id, quantity)
    }
  })
}

export function addSubscriptionVariant (variant, quantity) {
  const numAvailable = variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify' ? (
    variant.inventory_quantity
  ) : null // null means they can add as many as they want

  return fetchCart().then(({ items }) => {
    const existing = items.filter(item => (item.id === variant.id && item.properties))[0] || {}
    console.log('this is existing', existing)
    const numRequested = (existing.quantity || 0) + quantity
    console.log('add sub')
    if (numAvailable !== null && numRequested > numAvailable) {
      const err = `There are only ${numAvailable} of that product available, requested ${numRequested}.`
      ev.emit('error', err)
      throw new Error(err)
    } else {
      return addItemSubById(variant, quantity)
    }
  })
}

export function updateAddon (id, quantity) {
  return fetchCart().then(({ items }) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].variant_id === parseInt(id)) {
        return changeAddon(i + 1, quantity) // shopify cart is a 1-based index
      }
    }
  })
}

export function removeAddon (id) {
  return updateAddon(id, 0)
}


function changeAddon (line, quantity) {
  ev.emit('updating')

  return fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ line, quantity })
  }).then(res => res.json()).then(cart => {
    ev.emit('addon', { item: null, cart })
    if(window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function'){
      cart = BOLD.common.cartDoctor.fix(cart)
    }
    if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
      BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
    }
    app.hydrate({ cart: cart })(() => {
      const cartFooter = document.querySelector('.js-footer-cart')
      const cartBag = document.querySelector('.js-cart-drawer-toggle')
      if (cart.items.length <= 0) {
        cartFooter.classList.add('hidden')
        cartBag.classList.remove('active')
      }
    })
    return cart
  })
}

/**
 * Warning: this does not check available products first
 */
export function addItemById (id, quantity) {
  ev.emit('updating')

  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id, quantity })
  }).then(r => r.json()).then(item => {
    return fetchCart().then(cart => {
      app.hydrate({ cart: cart })(() => {

        const cartBag = document.querySelector('.js-cart-drawer-toggle')
        cartBag.classList.add('active')
        console.log('updated', cart)
      })
      app.actions.toggleCart()
      // ev.emit('updated', { item, cart })
      return { item, cart }
    })
  })
}

export function addItemSubById (variant, quantity) {
  ev.emit('updating')

  console.log('yo adddy')

  let baseData = {
    id: variant.id,
    quantity: quantity,
    properties: {
      'frequency_num': variant.properties.frequency_num,
      'frequency_type': variant.properties.frequency_type,
      'frequency_type_text': variant.properties.frequency_type_text,
      'group_id': variant.properties.group_id
    }
  }
  console.log('base data', baseData)
  // return fetch('/cart/add.js', {
  //   method: 'POST',
  //   credentials: 'include',
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   body: JSON.stringify({ id, quantity })
  // }).then(r => r.json()).then(item => {
  //   return fetchCart().then(cart => {
  //     app.hydrate({ cart: cart })(() => console.log('updated'))
  //     app.actions.toggleCart()
  //     // ev.emit('updated', { item, cart })
  //     return { item, cart }
  //   })
  // })
}

export function fetchCart () {
  return fetch('/cart.js', {
    method: 'GET',
    credentials: 'include'
  }).then(res => res.json())
}
